import { useEffect, useRef } from 'react'

export const useClickOutside = (elementRef, isOpen, onClose) => {
  const onCloseRef = useRef(onClose)
  onCloseRef.current = onClose

  useEffect(() => {
    if (!isOpen) return

    const handle = e => {
      if (elementRef.current && !elementRef.current.contains(e.target)) {
        onCloseRef.current()
      }
    }
    document.addEventListener('click', handle)

    return () => document.removeEventListener('click', handle)
  }, [elementRef, isOpen])
}
